<template>
  <!--  社区资料-->
    <div class="empty">
      <van-empty :description="langUtil(84)" />
    </div>
</template>

<script>

export default {
  name: "ListEmpty",
}
</script>

<style lang="less" scoped>
.empty{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

}
.d2{
  font-size: 12px;
  color: black;
}
.d3{
  width: 364px;
  height: 364px;
}

</style>
